import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getFormLibrariesList = createAsyncThunk("DocsLibrary/getFormsList", async (parent_folder_id, thunkAPI) => {
  try {
    let params = {};
    if (parent_folder_id) {
      params.folder_id = parent_folder_id;
    }

    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/docs/library/forms`, {
      headers: {
        "Content-Type": "application/json",
      },
      params: params,
    });

    return resp.data?.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
